enum ContractTradeTypeEnum {
  BUY = "buy",
  SELL = "sell",
}

export default ContractTradeTypeEnum;
